import styled from 'styled-components'

const ZestawienieRowStyle = styled.div`
  .row {
    display: grid;
    grid-template-columns: 1fr auto auto auto 32px;
    grid-template-areas: 'name a b b1 menupozycji';
    background-color: ${props => props.theme.black4onBlack4};
    padding: 12px 0 12px 20px;
    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    align-items: center;
    margin-bottom: 4px;

    :hover {
      border-left: 5px solid ${props => props.theme.primary500};
      padding-left: 15px;

      .menupozycji {
        display: block;
      }
    }
  }

  .edytowalny {
    background: #fff;
  }

  .value {
    margin-left: 16px;
    width: 136px;
  }

  .hidden {
    margin-left: 16px;
    display: none;
  }

  .menupozycji {
    grid-area: menupozycji;
    padding: 0 4px;
    display: none;
  }

  .name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .edycjanazwy {
    margin-right: 16px;
    display: grid;

    input {
      text-align: left;
    }
  }

  input,
  span {
    text-align: right;
  }

  .wciecie1 {
    padding-left: 16px;
  }

  .wciecie2 {
    padding-left: 32px;
  }

  .wciecie3 {
    padding-left: 48px;
  }

  .wciecie4 {
    padding-left: 64px;
  }

  .wciecie5 {
    padding-left: 80px;
  }

  .wstawpozycje_linia {
    height: 4px;
    background-color: transparent;
    position: relative;
    justify-items: center;
    align-items: center;
    display: grid;
    margin-top: 6px;
    transition: all 0.3s ease-in;
    opacity: 0;

    .wstawpozycje_button {
      position: absolute;
      height: 24px;
      padding: 0 12px;
      transition: all 0.3s ease-in;
      opacity: 0;
    }
  }

  .wstawpozycje_hoverplace {
    height: 16px;
    position: relative;
    background-color: transparent;
    margin: -10px 0 -6px 0;
    display: grid;

    :hover {
      .wstawpozycje_linia {
        background-color: ${props => props.theme.primary500};
        transition: all 0.1s ease-out;
        opacity: 1;

        .wstawpozycje_button {
          transition: all 0.1s ease-out;
          opacity: 1;
        }
      }
    }
  }
`

export default ZestawienieRowStyle
